<div class="mb-3">
  @if (!expanded) {
    <div class="expand-collapse" (click)="onExpandOrCollapseClick(true)">
      <mat-icon class="icon">chevron_right</mat-icon>
      <strong>Expand for Encounter Eligibility Details</strong>
    </div>
  }

  @if (expanded) {
    <div class="expand-collapse" (click)="onExpandOrCollapseClick(false)">
      <mat-icon class="icon">expand_more</mat-icon>
      <strong>Encounter Eligibility Details</strong>
    </div>
    <div class="content">
      @if (displayCaptureAdminContent) {
        <p>
          If an encounter type is marked as eligible, then encounters for this type will be used to satisfy patient care ownership.
        </p>
        <p>
          If an encounter type is <em>NEW</em> or marked ineligible, encounters for this type will not be used to satisfy patient care ownership.
        </p>
      } @else {
        <p>
          Encounter type data shared from your EHR is used to determine patient care ownership and eligibility for your 340B claim verifications. To ensure that claims are verified correctly, each encounter type must be reviewed and flagged appropriately.
        </p>

        <p><strong>Status Definitions:</strong></p>

        <ul>
          <li><strong class="eligibility-status eligible">ELIGIBLE</strong> – encounters of this type will be used to satisfy patient care ownership requirements and WILL count towards claim verifications.</li>
          <li><strong class="eligibility-status ineligible">INELIGIBLE</strong> – encounters of this type will not be used to satisfy patient care ownership and WILL NOT count towards claim verifications.</li>
          <li><strong class="eligibility-status new">NEW</strong> – this encounter type has not been reviewed. Encounters of this type will not be used to satisfy patient care ownership until the status is updated. Please review and update NEW encounter types promptly to avoid gaps in claim eligibility.</li>
        </ul>
      }
    </div>
  }
</div>

